import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SummaryCard from '../SummaryCard';

const JacketGotoCartButton = ({ onButtonClick, price, views, summaryData }) => {
  const [showSummary, setShowSummary] = useState(false);

  return (
    <div className="jacket-goto-cart">
      {showSummary && (
        <SummaryCard
          data={summaryData}
          onClose={() => setShowSummary(!showSummary)}
        />
      )}
      <div
        className="jacket-goto-cart_left"
        onClick={() => setShowSummary(!showSummary)}
      >
        <div className="jacket-goto-cart_left-text">view your result</div>
        <div className="jacket-goto-cart_eye">
          {views && <span className="jacket-goto-cart_eye-msg">{views}</span>}
          <img
            src="https://reecommdev.blob.core.windows.net/re-assets/jacketAssets/icons/eye-icon.png"
            alt=""
            className="jacket-goto-cart_eye-img"
          />
        </div>
      </div>
      <div className="jacket-goto-cart_right">
        <button
          type="button"
          onClick={onButtonClick}
          className="jacket-goto-cart_button"
        >
          <div className="jacket-goto-cart_price-wrapper">
            <span className="jacket-goto-cart_price">₹{price}</span>
            <span className="jacket-goto-cart_button-text">add to cart</span>
          </div>
          <div
            className="jacket-goto-cart_icon"
            style={{
              maskImage: `url(${'https://reecommdev.blob.core.windows.net/re-assets/icons/cart.svg'})`,
              WebkitMaskImage: `url(${'https://reecommdev.blob.core.windows.net/re-assets/icons/cart.svg'})`
            }}
          />
          <div
            className="jacket-goto-cart_icon jacket-goto-cart_icon_arrow"
            style={{
              maskImage: `url(${'https://reecommdev.blob.core.windows.net/re-assets/icons/arrow-right.svg'})`,
              WebkitMaskImage: `url(${'https://reecommdev.blob.core.windows.net/re-assets/icons/arrow-right.svg'})`
            }}
          />
        </button>
      </div>
    </div>
  );
};

JacketGotoCartButton.propTypes = {
  price: PropTypes.string,
  onButtonClick: PropTypes.func,
  views: PropTypes.number
};

export default JacketGotoCartButton;
